import React from 'react';

const ServicesBlock = ({ 
  title = "WOODEN SELFS", 
  description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do labore et dolore magna aliqua",
  svg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/> */}
      {/* <!-- Sewer pipe --> */}
  <rect x="10" y="40" width="60" height="20" rx="10" fill="currentColor" stroke="currentColor" stroke-width="2"/>
  
  {/* <!-- Cleaning brush/spiral --> */}
  <circle cx="75" cy="50" r="8" fill="none" stroke="currentColor" stroke-width="2"/>
  <path d="M 70 45 Q 75 40 80 45 Q 75 50 70 55 Q 75 60 80 55" fill="none" stroke="currentColor" stroke-width="2"/>
  
  {/* <!-- Cleaning equipment handle --> */}
  <line x1="83" y1="50" x2="95" y2="50" stroke="currentColor" stroke-width="3"/>
  
  {/* <!-- Water/cleaning flow --> */}
  <circle cx="25" cy="35" r="2" fill="currentColor"/>
  <circle cx="35" cy="30" r="1.5" fill="currentColor"/>
  <circle cx="45" cy="35" r="2" fill="currentColor"/>
  <circle cx="55" cy="30" r="1.5" fill="currentColor"/>
  
  {/* <!-- Pipe joints --> */}
  <line x1="30" y1="35" x2="30" y2="65" stroke="currentColor" stroke-width="1"/>
  <line x1="50" y1="35" x2="50" y2="65" stroke="currentColor" stroke-width="1"/>
  
  {/* <!-- Debris being removed --> */}
  <rect x="20" y="70" width="3" height="2" fill="currentColor"/>
  <rect x="28" y="72" width="2" height="3" fill="currentColor"/>
  <rect x="35" y="70" width="2" height="2" fill="currentColor"/>
    </svg>
  )
}) => {
  const styles = {
    card: {
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
      padding: '32px',
      maxWidth: '320px',
      width: '250px',
      // margin: '0 auto',
      textAlign: 'center',
      position: 'relative',
      minHeight: '250px',
      maxHight: 'fit-content',
    //   overflow: 'hidden'
    },
    decorativeElement1: {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '64px',
      height: '64px',
      backgroundColor: 'rgba(85, 197, 135, 0.2)',
      borderBottomRightRadius: '50%'
    },
    decorativeElement2: {
      position: 'absolute',
      top: '0',
      right: '0',
      width: '48px',
      height: '48px',
      backgroundColor: 'rgba(0, 75, 0, 0.2)',
      borderBottomLeftRadius: '50%'
    },
    decorativeElement3: {
      position: 'absolute',
      bottom: '0',
      left: '0',
      width: '80px',
      height: '80px',
      backgroundColor: 'rgba(9, 255, 0, 0.23)',
      borderTopRightRadius: '50%'
    },
    logoContainer: {
      position: 'relative',
      zIndex: '100',
      marginBottom: '-35px'
    },
    logoWrapper: {
      display: 'inline-block',
      // padding: '0 10px',
    },
    logo: {
      width: '64px',
      height: '64px',
      position: "relative",
      top: "-65px",
      // left: "60px",
      borderRadius: '50%',
      backgroundColor: '#2B914C',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto',
      transition: 'all 0.5s ease',
      transform: 'rotateY(0deg) scale(1)',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      cursor: 'pointer'
    },
    logoHover: {
      backgroundColor: '#22c55e',
      transform: 'rotateY(180deg) scale(1.1)'
    },
    svgContainer: {
      width: '52px',
      height: '52px',
      color: 'white',
      transition: 'transform 0.5s ease',
      transform: 'rotateY(0deg)'
    },
    svgContainerHover: {
      transform: 'rotateY(180deg)'
    },
    title: {
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#1f2937',
      marginBottom: '16px',
      letterSpacing: '0.05em'
    },
    description: {
      color: '#6b7280',
      fontSize: '14px',
      lineHeight: '1.6'
    }
  };

  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div  style={styles.card}>
      {/* Decorative background elements */}
      <div style={styles.decorativeElement1}></div>
      <div style={styles.decorativeElement2}></div>
      <div style={styles.decorativeElement3}></div>
      
      {/* Logo with hover animation */}
      <div style={styles.logoContainer}>
        <div style={styles.logoWrapper}>
          <div 
            style={{
              ...styles.logo,
              ...(isHovered ? styles.logoHover : {})
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <div style={{
              ...styles.svgContainer,
              ...(isHovered ? styles.svgContainerHover : {})
            }}>
              {svg}
            </div>
          </div>
        </div>
      </div>

      {/* Title */}
      <h3 style={styles.title}>
        {title}
      </h3>

      {/* Description */}
      <p style={styles.description}>
        {description}
      </p>
    </div>
  );
};

export default ServicesBlock;